import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { updateOrdersAction } from "../../MyApi/orders";

const FullOrderRefundModal = ({ isOpen, toggle, orderId, onSuccess ,refetchOrder }) => {
  const [formData, setFormData] = useState({
    action_type: "refund_full_order",
    reason: ""
  });

  const mutation = useMutation(
    (refundData) => updateOrdersAction(refundData, orderId),
    {
      onSuccess: (data) => {
        toast.success("تم استرداد الطلب بالكامل بنجاح");
        onSuccess();
        toggle();
        refetchOrder()
      },
      onError: (error) => {
        toast.error("فشل في استرداد الطلب بالكامل");
      }
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.reason.trim()) {
      toast.error("يرجى إدخال سبب الاسترداد");
      return;
    }
    mutation.mutate(formData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        استرداد طلب كامل
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="text-center mb-4">
            <div className="alert alert-warning">
              <strong>تحذير:</strong> هذا الإجراء سيؤدي إلى استرداد قيمة الطلب بالكامل
            </div>
          </div>
          
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">سبب الاسترداد</label>
              <textarea
                className="form-control"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                rows="4"
                placeholder="يرجى إدخال سبب استرداد الطلب بالكامل..."
                required
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button 
              type="button" 
              className="btn btn-white" 
              onClick={toggle}
              disabled={mutation.isLoading}
            >
              إلغاء
            </button>
            <button 
              type="submit" 
              className="btn btn-danger"
              disabled={mutation.isLoading}
            >
              {mutation.isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  جاري المعالجة...
                </>
              ) : (
                "تأكيد استرداد الطلب بالكامل"
              )}
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default FullOrderRefundModal;